import component from './promocode-has-package.component';

export default angular
  .module('fizyweb.paycell.promocode.has.package', [])
  .component('fizyPaycellPromocodeHasPackage', component).name;



// WEBPACK FOOTER //
// src/app/components/promocode-has-package/promocode-has-package.module.ts